import '.g{display:flex;}.ssr-plugin'
import '.h{justify-content:center;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.bf{gap:0.5rem;}.ssr-plugin'
import '.bc{cursor:pointer;}.ssr-plugin'
import '.hw{padding:0.75rem;}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.bk{border:var(--blue-border);}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.cz{transition:background-color 0.2s ease;}.ssr-plugin'
import '.do{width:2.5rem;}.ssr-plugin'
import '.dp{height:2.5rem;}.ssr-plugin'
import '.hx{color:var(--shades-blue-700);}.ssr-plugin'
import '.hy{font-size:0.9rem;}.ssr-plugin'
import '.b3{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="g h k l bf bc hw ad bk ae cz"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="do dp g l h hx"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hy hx b3"
        >
          {label}
        </span>
      </styled.button>
    )
}